import { c as _c } from "react/compiler-runtime";
import { Accordion, Skeleton } from '@systemeio/components';
import { ArrowDownIcon } from '@systemeio/icons';
import AffiliateDashboardPromotionLink from 'modules/affiliate-dashboard/components/affiliate-dashboard-promotion-link';
import { useAffiliateDashboardPromotion } from 'modules/affiliate-dashboard/hooks/use-affiliate-dashboard-promotion';
import { AffiliateDashboardPromotionInterface } from 'modules/affiliate-dashboard/types/affiliate-dashboard-promotion-interface';
import React, { useState, type JSX } from 'react';
import { Hint } from 'shared/components';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
interface AffiliatePromotionProps {
  affiliateId?: string;
}
const AffiliateDashboardPromotion = t0 => {
  const $ = _c(57);
  const {
    affiliateId
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const [opened, setOpened] = useState(false);
  const {
    data: affiliatePromotion
  } = useAffiliateDashboardPromotion(opened);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = value => setOpened(value.includes("statistics"));
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== opened) {
    t2 = opened ? ["statistics"] : [];
    $[1] = opened;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t) {
    t3 = t("dashboard.affiliate_dashboard.promote_first");
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <span className="text-text-primary text-[17px] font-bold">{t3}</span>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== opened || $[8] !== t) {
    t5 = opened ? t("dashboard.affiliate_dashboard.hide_stats") : t("dashboard.affiliate_dashboard.show_stats");
    $[7] = opened;
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t5) {
    t6 = <span className="text-text-link desktop:inline hidden">{t5}</span>;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <ArrowDownIcon className="text-icon-accent transition-base size-5 shrink-0 group-data-panel-open:rotate-180" />;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t6) {
    t8 = <Accordion.Header><Accordion.Trigger className="group focus-visible:focus-ring-primary flex items-center gap-1.5 rounded-md p-0 font-normal outline-none">{t6}{t7}</Accordion.Trigger></Accordion.Header>;
    $[13] = t6;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t4 || $[16] !== t8) {
    t9 = <div className="flex justify-between gap-3">{t4}{t8}</div>;
    $[15] = t4;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t) {
    t10 = t("dashboard.affiliate_dashboard.promote_second");
    $[18] = t;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t10) {
    t11 = <span className="text-text-primary">{t10}</span>;
    $[20] = t10;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t11 || $[23] !== t9) {
    t12 = <div className="flex flex-col gap-1">{t9}{t11}</div>;
    $[22] = t11;
    $[23] = t9;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== affiliateId) {
    t13 = <AffiliateDashboardPromotionLink affiliateId={affiliateId} />;
    $[25] = affiliateId;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== t) {
    t14 = t("dashboard.affiliate.last_30_days");
    $[27] = t;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== t) {
    t15 = t("dashboard.affiliate_dashboard.freemium_registrations");
    $[29] = t;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== t14 || $[32] !== t15) {
    t16 = <Hint label={t14}>{t15}</Hint>;
    $[31] = t14;
    $[32] = t15;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] !== affiliatePromotion || $[35] !== t16) {
    t17 = <AffiliatePromotionContent affiliatePromotion={affiliatePromotion} title={t16}>{_temp}</AffiliatePromotionContent>;
    $[34] = affiliatePromotion;
    $[35] = t16;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] !== t) {
    t18 = t("dashboard.affiliate.current_active");
    $[37] = t;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  let t19;
  if ($[39] !== t) {
    t19 = t("dashboard.affiliate_dashboard.active_customers");
    $[39] = t;
    $[40] = t19;
  } else {
    t19 = $[40];
  }
  let t20;
  if ($[41] !== t18 || $[42] !== t19) {
    t20 = <Hint label={t18}>{t19}</Hint>;
    $[41] = t18;
    $[42] = t19;
    $[43] = t20;
  } else {
    t20 = $[43];
  }
  let t21;
  if ($[44] !== affiliatePromotion || $[45] !== t20) {
    t21 = <AffiliatePromotionContent affiliatePromotion={affiliatePromotion} title={t20}>{_temp2}</AffiliatePromotionContent>;
    $[44] = affiliatePromotion;
    $[45] = t20;
    $[46] = t21;
  } else {
    t21 = $[46];
  }
  let t22;
  if ($[47] !== t17 || $[48] !== t21) {
    t22 = <Accordion.Panel><Accordion.Content className="p-0"><div className="flex justify-between gap-3">{t17}{t21}</div></Accordion.Content></Accordion.Panel>;
    $[47] = t17;
    $[48] = t21;
    $[49] = t22;
  } else {
    t22 = $[49];
  }
  let t23;
  if ($[50] !== t12 || $[51] !== t13 || $[52] !== t22) {
    t23 = <Accordion.Item className="bg-bg-primary border-border-100 flex w-full flex-col gap-3 overflow-x-hidden rounded-lg border px-6 py-4" value="statistics">{t12}{t13}{t22}</Accordion.Item>;
    $[50] = t12;
    $[51] = t13;
    $[52] = t22;
    $[53] = t23;
  } else {
    t23 = $[53];
  }
  let t24;
  if ($[54] !== t2 || $[55] !== t23) {
    t24 = <Accordion.Root onValueChange={t1} value={t2}>{t23}</Accordion.Root>;
    $[54] = t2;
    $[55] = t23;
    $[56] = t24;
  } else {
    t24 = $[56];
  }
  return t24;
};
const AffiliatePromotionContent = t0 => {
  const $ = _c(8);
  const {
    affiliatePromotion,
    children,
    title
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = <span className="text-text-primary">{title}</span>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== affiliatePromotion || $[3] !== children) {
    t2 = affiliatePromotion ? <span className="text-text-primary text-[17px] font-bold">{children(affiliatePromotion)}</span> : <Skeleton className="w-fit rounded-lg px-5 text-transparent">.</Skeleton>;
    $[2] = affiliatePromotion;
    $[3] = children;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <div className="flex w-1/2 flex-col justify-between gap-3">{t1}{t2}</div>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
export default AffiliateDashboardPromotion;
function _temp(affiliatePromotion_0) {
  return affiliatePromotion_0.freeRegistrationsCount;
}
function _temp2(affiliatePromotion_1) {
  return affiliatePromotion_1.paidCount;
}